import { connect } from "react-redux";
import Component from "./ChangePasswordContainer";

export default connect(
      ({ auth: { user } }) => ({ user }),
      ({ auth: { changePassword } }) => ({ changePassword })
)(Component);
